export default __webpack_public_path__ + "static/media/sing-up.c2d56062.png";